import React from "react";
import "../styles/badgeInfo.css"; // CSS für Badge-Stil

/**
 * Zeigt den Festival-Badge des Helfers in einer hübschen Box.
 */
const BadgeInfo = ({ badges }) => {
    if (!badges || badges.length === 0) return null;

    // ============================================================
    // HELPER:
    // Wandelt Badge-Namen nur für die Anzeige um.
    // Backend-Daten bleiben unverändert.
    // ============================================================
    const getDisplayBadgeName = (badgeName) => {
        if (!badgeName) return "";

        // Nur dieser eine Name soll umbenannt werden
        if (badgeName === "Superhelfer") {
            return "Superhelfer:in";
        }

        return badgeName;
    };

    return (
        <div className="badge-container">
            <strong className="badge-title">
                FestivalBadge 🏅
            </strong>

            {badges.map((badge) => (
                <div key={badge.badgeId} className="badge-name">
                    {getDisplayBadgeName(badge.badge)}
                </div>
            ))}
        </div>
    );
};

export default BadgeInfo;